import { Signal } from '@angular/core';
import { AbsenceType } from '@app/shared/types/enums/absence-type';
import { HoursType } from '@app/shared/types/enums/hours-type';
import { RegistrationType } from '@app/shared/types/enums/registration-type';
import { TimeZone } from '@app/shared/types/enums/time-zone';
import { Location } from '@app/shared/types/models/location/location.model';
import { Task } from '@app/shared/types/models/task/task.model';

export class WorkTimeRegistration {
  public id: string | undefined;
  public registrationType: RegistrationType | undefined;
  public reportUtcDate: Date | undefined;
  public reportTimeZone: TimeZone | undefined;
  public manualHours: string | undefined;
  public rangeFrom?: Date;
  public rangeTo?: Date;
  public task: Signal<Task> | undefined;
  public location: Signal<Location> | undefined;
  public description?: string;
  public comments?: string;
  public hoursType: HoursType | undefined;
  public absenceType: AbsenceType | undefined;
  public correlationId?: string;
  public projectTaskTimerEntryId?: string;

  public constructor(value: Partial<WorkTimeRegistration>) {
    Object.assign(this, value);
  }
}
